import React from "react";
import "./Trailer.css";

const Trailer1 = () => {
    return (
        <div className="vide__section">
            <iframe key="KydqdKKyGEk" class="elementForYTiframe" allowfullscreen="1" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" title="The Super Mario Bros. Movie | Official Teaser Trailer" src="https://www.youtube-nocookie.com/embed/KydqdKKyGEk?rel=0&amp;enablejsapi=1&amp;origin=https%3A%2F%2Fwww.thesupermariobros.movie&amp;widgetid=15" id="widget16" width="100%" height="100%" frameborder="0"></iframe>

        </div>
    )
}
export default Trailer1;